import { CatalystMock } from './CatalystConstants';

const CatalystConfig = {
  getNewPageEventName() {
    return CatalystMock.newPageEvent;
  },
  getPrefix() {
    return CatalystMock.prefix;
  },
  getPageNames() {
    return CatalystMock.PageNames;
  },
  getDefaultVisitorData() {
    return CatalystMock.VisitorData;
  },
  getDefaultSearchData() {
    return CatalystMock.SearchData;
  },
  getDefaultPageData() {
    return CatalystMock.PageData;
  },
  setNoTracking(val) {
    CatalystMock.PageData.noTracking = val;
  },
};

export default CatalystConfig;
